import { FC } from 'react';

import { Stack } from '@mui/system';

import WaveUINotificationBar from '@/shared/components/utilities/WaveUINotificationBar';
import useModalDialog from '@/shared/hooks/useModalDialog';
import useNotificationBar from '@/shared/hooks/useNotificationBar';
import BookingsContact from '@/shared/types/bookings/contact.type';
import DialogName from '@/shared/types/dialogName.enum';

import AddContactFormDialog from './components/AddContactFormDialog';
import ContactDetailsForm from './components/ContactDetailsForm';
import GoogleCalendarsAccountsTable_v2 from './components/GoogleCalendarsAccountsTable_v2/GoogleCalendarsAccountsTable_v2';
import useUserSettingsOperations from './hooks/useUserSettingsOperations';

const UserSettings: FC = () => {
  const { dialog, onUpdateDialogState } = useModalDialog<
    BookingsContact,
    DialogName
  >();

  const { notificationBar, onUpdateNotificationBar } = useNotificationBar();

  const {
    timezones,
    refreshTableIndex,
    handleCreateContact,
    handleUpdateContact,
    handleReauthorizeAccount,
  } = useUserSettingsOperations({
    dialog,
    onUpdateDialogState,
    onUpdateNotificationBar,
  });

  return (
    <Stack spacing={2}>
      <ContactDetailsForm />

      <GoogleCalendarsAccountsTable_v2
        refreshTableIndex={refreshTableIndex}
        onOpenAddAccountDialog={() => {
          onUpdateDialogState(DialogName.ManageContact, {
            open: true,
            errors: [],
            data: null,
          });
        }}
        onOpenUpdateAccountDialog={(contact) => {
          onUpdateDialogState(DialogName.ManageContact, {
            open: true,
            data: contact,
            errors: [],
          });
        }}
        onReauthorizeAccount={(contact, contactId) => {
          void handleReauthorizeAccount(contact, contactId);
        }}
      />

      {dialog?.manageContact?.open && (
        <AddContactFormDialog
          initialFormValues={dialog.manageContact?.data || null}
          timezones={timezones}
          onCreateContact={(formValues) => {
            void handleCreateContact(formValues);
          }}
          onUpdateContact={(formValues) => {
            void handleUpdateContact(formValues);
          }}
          onClose={() => {
            onUpdateDialogState(DialogName.ManageContact, {
              open: false,
              errors: [],
            });
          }}
        />
      )}

      <WaveUINotificationBar
        message={notificationBar.message}
        severity={notificationBar.severity}
        open={notificationBar.open}
        close={() => onUpdateNotificationBar({ open: false })}
      />
    </Stack>
  );
};

export default UserSettings;
